module.exports = "label{margin-bottom:0;margin-left:8px}.icono{padding:0}.container-icono{width:8%;text-align-last:center}.sub-element{margin-left:2%}\n"